import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const EditExpression = props => {
  const handleClick = () => {
    // get item from columns or rows data grid
    const items = props[props.gridType];
    const item = items && items[props.index - 1];
    // if item exists run handler func
    if (item) {
      props.handleEditExpression(item.id, item.dataSmartSearch);
    }
  };

  return (
    <button className="editTitle" onClick={handleClick}>
      Edit Expression
    </button>
  );
};

EditExpression.propTypes = {
  index: PropTypes.number, // index of column or row
  handleEditExpression: PropTypes.func, // func to run on click
  gridType: PropTypes.string, // ColumnsDataGrid or RowsDataGrid
};

function mapStateToProps(state) {
  return {
    ColumnsDataGrid: state.crosstab.ColumnsDataGridData,
    RowsDataGrid: state.crosstab.RowsDataGridData,
  };
}

export default connect(mapStateToProps)(EditExpression);
